import { render, staticRenderFns } from "./Multipletable.vue?vue&type=template&id=645e0a8c&"
import script from "./Multipletable.vue?vue&type=script&lang=js&"
export * from "./Multipletable.vue?vue&type=script&lang=js&"
import style0 from "./Multipletable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports